export const permissions = (state) => state.permissions

export const shopPermissions = (state) => state.shopPermissions

export const contextShopId = (state) => state.contextShopId

export const permissionLabels = (state) => state.permissionLabels

